import { useTranslation } from "react-i18next";
import { App } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { ReactNode } from "react";

const useFrontDelTip = <Res, Params extends Array<unknown> = Array<unknown>>({ cb, message, desc, content, rejectOnCancel = false }: {
  cb: (...args: Params) => Promise<Res>,
  message?: string,
  desc?: string,
  content?: ReactNode,
  rejectOnCancel?: boolean
}) => {
  const { modal } = App.useApp();
  const { t } = useTranslation();

  const onConfirm = async (...args: Params) => {
    return new Promise<Res>((resolve, reject) => {
      let submitting = false;
      modal.confirm({
        title: (
          <span
            dangerouslySetInnerHTML={{
              __html: message ?? t("common.rmTip"),
            }}
          />
        ),
        icon: <ExclamationCircleFilled />,
        content: content || <span dangerouslySetInnerHTML={{ __html: desc ?? t("common.rmContent") }} />,
        cancelText: t("common.cancel"),
        okText: t("common.confirm"),
        onOk: async () => {
          submitting = true;
          try { const res = await cb(...args); resolve(res) }
          catch (err) { reject(err); }
        },
        onCancel: () => {
          // 仅在提交前取消时结束等待
          if (rejectOnCancel && !submitting) {
            reject(new DOMException("Confirmation cancelled", "AbortError"));
          }
        }
      });
    })
  };

  return { onConfirm };
};

export default useFrontDelTip;
